<template>
  <el-container>
    <!-- 主体内容 -->
    <el-header style="display: flex; align-items: center; justify-content: space-between">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>工单办理</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button-group>
        <el-button type="info" icon="el-icon-chat-line-square" @click.native="formSubmit(1)"
          v-if="data.form.selectType == 2" :disabled="data.form.message == ''">
          提交答复
        </el-button>

        <el-button type="info" icon="el-icon-chat-line-square" @click.native="formSubmit(1)"
          v-if="data.form.selectType == 3" :disabled="data.form.message == '' || data.lastNode.id == ''">
          工单退回
        </el-button>

        <el-button type="info" icon="el-icon-coin" @click.native="formSubmit(0)" v-if="
          data.form.selectType == 2 ||
          data.form.selectType == 3 ||
          data.form.isExtension
        " :disabled="data.form.message == ''">
          保存
        </el-button>

        <el-button type="info" icon="el-icon-coin" @click.native="formSubmit(0)" v-if="data.form.selectType == 4"
          :disabled="data.form.extensionMessage == ''">
          申请疑难件
        </el-button>
        <el-button type="info" icon="el-icon-coin" @click.native="formSubmit(0)" v-if="data.form.selectType == 5"
          :disabled="data.form.extensionMessage == ''">
          申请延期
        </el-button>
        <el-button type="info" icon="el-icon-printer" @click.native="print">
          工单呈报单
        </el-button>
        <el-button type="info" icon="el-icon-eleme" @click.native="browser">
          舆情来源
        </el-button>
        <el-button type="info" icon="el-icon-arrow-left" @click.native="formReturn">
          返 回
        </el-button>
      </el-button-group>
    </el-header>
    <el-main>
      <el-tabs type="card" :tab-position="tabPosition" @tab-click="tabclick" v-model="activeTabName">
        <el-tab-pane :key="0" name="tabFirst">
          <span slot="label"><i class="el-icon-date"></i> 工单信息</span>
          <el-form :model="data.pst" status-icon label-width="100px">
            <el-form-item label="录入单位" prop="unitName">
              <el-input v-model="data.pst.unitName" disabled />
            </el-form-item>
            <el-form-item label="录入人" prop="userName">
              <el-input v-model="data.pst.userName" disabled />
            </el-form-item>
            <el-form-item label="舆情类别" prop="pstType">
              <el-input v-model="data.pstTypeName" disabled />
            </el-form-item>
            <el-form-item label="发贴标题" prop="title">
              <el-input v-model="data.pst.title" disabled />
            </el-form-item>
            <el-form-item label="发贴人" prop="name">
              <el-input v-model="data.pst.name" disabled />
            </el-form-item>
            <el-form-item label="发贴时间" prop="postingTime">
              <el-input v-model="data.pst.postingTime" disabled />
            </el-form-item>
            <el-form-item label="来源" prop="pstSource">
              <el-input v-model="data.pst.pstSource" disabled />
            </el-form-item>
            <el-form-item label="贴子内容" prop="pstContent">
              <el-input type="textarea" :rows="10" v-model="data.pst.pstContent" disabled />
            </el-form-item>
            <el-form-item label="状态" prop="statusName">
              <el-input v-model="data.statusName" disabled />
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <!-- 显示节点 -->
        <el-tab-pane v-for="node in data.nodes" :key="node.id" :name="'tab' + node.id">
          <span slot="label"><i :class="pstApi.getStatusIcon(node.status)"></i>
            {{ pstApi.getNodeTitle(node.status) }}</span>
          <el-form :model="node" status-icon>
            <el-form-item label="办理单位">
              <el-input v-model="node.unitName" disabled />
            </el-form-item>
            <el-form-item label="办理人">
              <el-input v-model="node.userName" disabled />
            </el-form-item>
            <el-form-item label="转办单位" v-if="node.status == 1">
              <el-input v-model="node.transferUnitName" disabled />
            </el-form-item>
            <el-form-item label="上级答复" v-if="node.nodeContent">
              <el-input type="textarea" :rows="2" v-model="node.nodeContent" disabled />
            </el-form-item>
            <el-form-item label="提交说明" v-if="node.nodeMessage">
              <el-input type="textarea" :rows="node.status == 2 ? 15 : 2" v-model="node.nodeMessage" disabled />
            </el-form-item>
            <el-form-item :label="pstApi.getTimeTitle(node.status)" v-if="node.isSucces">
              <el-input :value="node.lastTime
                ? Common.dateFormatter(node.lastTime, 'yyyy-MM-dd hh:mm')
                : ''
                " disabled />
            </el-form-item>
            <el-form-item label="佐证材料" v-if="node.uploadCount > 0">
              <el-card class="box-card">
                <!-- 文件上传组件 -->
                <upload :nodeId="node.id" :disabled="true" />
              </el-card>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <!-- 答复信息 -->
        <el-tab-pane :key="data.nodes.length + 1" name="tabLast">
          <span slot="label"><i class="el-icon-position"></i>
            <font color="green"> 工单答复 </font>
          </span>
          <el-form :model="data.lastNode" ref="pstRef" status-icon label-width="120px">
            <el-form-item label="办理时间">
              <el-input v-model="data.pst.timeIntervalString" disabled />
            </el-form-item>
            <el-form-item label="办理方式">
              <div style="display: flex; justify-self: start; align-items: center">
                <el-radio-group v-model="data.form.selectType" @input="radioChange"
                  :disabled="data.lastNode.isSucces == true">
                  <el-radio :label="2">工单答复</el-radio>
                  <el-radio :label="3">工单退回</el-radio>
                  <el-radio :disabled="data.form.isExtension" :label="4">申请疑难件</el-radio>
                  <el-radio :disabled="data.form.isExtension" :label="5">申请延期</el-radio>
                </el-radio-group>
                <div class="ml-2">
                  <div v-if="data.form.selectType == 5 || data.form.isExtension">
                    <el-input v-model="data.form.extension" style="width: 60px"
                      :disabled="data.form.isExtension" /><span class="ml-2">天</span>
                  </div>
                  <div v-else>&nbsp;</div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="上级回复" v-if="data.lastNode.nodeContent">
              <el-input type="textarea" :rows="1" v-model="data.lastNode.nodeContent" disabled />
            </el-form-item>
            <el-form-item label="申请原因" v-if="data.form.selectType == 4 || data.form.selectType == 5">
              <el-input type="textarea" :rows="3" v-model="data.form.extensionMessage"
                :disabled="data.form.isExtension" />
            </el-form-item>
            <el-form-item :label="data.form.selectType == 2
              ? '舆情答复'
              : data.form.selectType == 3
                ? '退回理由'
                : '答复或退回理由'
              " v-if="
                data.form.selectType == 2 ||
                data.form.selectType == 3 ||
                data.form.isExtension
              ">
              <el-input type="textarea" :rows="10" v-model="data.form.message" :disabled="data.lastNode.isSucces" />
              <div v-if="data.form.selectType == 2" style="text-align: center;margin-top: 10px;">
                <el-button-group>
                  <el-Button type="info" :disabled="ai.disable || data.form.message == ''" @click="callDeepSeek">
                    AI审稿
                  </el-Button>
                  <el-Button type="info" :disabled="ai.disable || data.form.message == '' || ai.isAudit == false"
                    @click="ai.isAudit = false">
                    关闭建议
                  </el-Button>
                </el-button-group>
              </div>
            </el-form-item>
            <el-form-item v-if="data.form.selectType == 2 && ai.isAudit == true" label="AI建议">
              <el-input v-model="ai.result" type="textarea" :rows="10" disabled />
            </el-form-item>
            <el-form-item v-if="data.lastNode.id" label="上传佐证">
              <el-card class="box-card">
                <!-- 文件上传组件 -->
                <upload :nodeId="data.lastNode.id" @uploadchange="uploadchange" :disabled="data.lastNode.isSucces" />
              </el-card>
            </el-form-item>
            <el-form-item label="发贴标题" prop="title">
              <el-input v-model="data.pst.title" disabled />
            </el-form-item>
            <el-form-item label="贴子内容" prop="pstContent">
              <el-input type="textarea" :rows="10" v-model="data.pst.pstContent" disabled />
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-main>
  </el-container>
</template>

<script>
import upload from "../../../components/Contents.vue";
export default {
  components: {
    upload,
  },
  created() {
    this.pstApi.setWindowTitle("工单答复办理");
    this.data.pst.id = this.$route.params.id;
    this.componentName = this.$route.params.componentName;
    this.data.user = this.pstApi.getUserData();

    this.getPst(); //读取留言信息
  },
  data() {
    return {
      tabPosition: "right",
      tabIndex: 0,
      activeTabName: "tabLast",
      componentName: "",
      ai: {
        disable: false,
        isAudit: false,
        result: ''
      },
      //数据项
      data: {
        user: "",
        statusName: "",
        pstTypeName: "",
        units: [], //单位数据
        pst: {
          id: "",
        },
        nodes: [],
        //转办数据
        lastNode: {
          id: "",
          isSucces: false,
          lastTime: "",
          nodeContent: "",
          nodeMessage: "",
          pstId: "",
          pstType: 0,
          status: 2,
          transferUnitId: "",
          transferUnitName: "",
          unitId: "",
          unitName: "",
          userId: "",
          userName: "",
          uploadCount: 0,
          isExtension: false,
          extension: 0,
          extensionMessage: "",
        },
        form: {
          selectType: 2,
          extension: 1,
          message: "",
          extensionMessage: "",
          lsextension: 0,
          isExtension: true,
        },
      },
    };
  },
  methods: {
    callDeepSeek() {
      if (this.data.form.message == '') {
        this.$toast("答复内容不能为空");
        return;
      }
      this.ai.disable = true
      const loading = this.$loading({
        lock: true,
        text: 'AI正在为您审稿，请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.pstApi.callDeepSeek_Text(this.data.form.message)
        .then((res) => {
          loading.close();
          this.ai.result = res.data
          this.ai.isAudit = true
          this.ai.disable = false
        })
        .catch((err) => {
          loading.close();
          this.$toast("Ai审稿失败");
          this.ai.disable = false
        })
    },
    //读取舆情信息
    getPst() {
      this.pstApi
        .getHandlePstInfo(this.data.pst.id)
        .then((res) => {
          var data = res.data;
          //console.log(data);
          this.data.pst = data;
          // console.log(this.data.user);
          //
          //console.log(data.nodeInfos);
          var replyNodes = data.nodeInfos.filter(
            (node) => node.isSucces == false
          );
          //console.log(replyNodes);
          if (replyNodes.length > 0) {
            this.data.lastNode = replyNodes[0];
            // console.log(this.data.lastNode);
          }

          if (this.data.pst.extension < 0) {
            this.data.form.selectType = 4;
            this.data.form.extensionMessage = this.data.pst.extensionMessage;
            this.data.form.isExtension = this.data.pst.isExtension;
            if (this.data.form.isExtension) {
              this.data.form.selectType = 2;//已审核的疑难项，仅可答复与退回
            }
          } else if (this.data.pst.extension > 0) {
            this.data.form.selectType = 5;
            this.data.form.extension = this.data.pst.extension;
            this.data.form.extensionMessage = this.data.pst.extensionMessage;
            this.data.form.isExtension = this.data.pst.isExtension;
            if (this.data.form.isExtension) {
              this.data.form.selectType = 2;//已审核的延期项，仅可答复与退回
            }
          } else {
            this.data.form.selectType = this.data.lastNode.status;
            this.data.form.isExtension = this.data.pst.isExtension;
          }

          this.data.form.message = this.data.lastNode.nodeMessage;
          // console.log(this.data.form.message)
          this.data.lastNode.unitId = this.data.user.unitId;
          this.data.lastNode.unitName = this.data.user.unitName;
          this.data.lastNode.userId = this.data.user.userId;
          this.data.lastNode.userName = this.data.user.name;

          this.data.nodes = data.nodeInfos.filter(
            (node) => node.isSucces == true
          );

          this.data.statusName = this.pstApi.getStatusTransferTitle(
            data.status
          );
          this.data.pstTypeName = this.pstApi.getPstTypeName(data.pstType);
        })
        .catch((err) => {
          this.$toast("读取失败");
        });
    },
    async formSubmit(buttonType) {
      let pstId = this.data.pst.id;
      let submitType = buttonType;
      let status = this.data.form.selectType;
      let message = this.data.form.message;
      let extension = this.data.form.extension;
      let extensionMessage = this.data.form.extensionMessage;
      let uploadCount = this.data.lastNode.uploadCount;
      if (status == 5 && extension <= 0) {
        this.$toast("延期天数无效");
        return;
      }

      if (status == 2 && message == "") {
        this.$toast("请填写答复内容");
        return;
      }
      if (status == 3 && message == "") {
        this.$toast("请填写退回理由");
        return;
      }
      if ((status == 4 || status == 5) && extensionMessage == "") {
        this.$toast("请填写延期理由");
        return;
      }
      if (submitType == 1 && status == 3 && uploadCount == 0) {
        this.$toast("请上传退回佐证材料");
        return;
      }
      if (submitType == 1 && message == "") {
        this.$toast("请填写答复内容");
        return;
      }

      if (status == 2 || status == 3) {
        extension = 0;
      } else if (status == 4) {
        extension = -1;
      }
      // console.log("status:", status);
      // console.log("extension:", extension);
      // console.log("答复通过");
      //return;
      //开始答复处理
      var res = await this.pstApi
        .pstReply(
          pstId,
          submitType,
          status,
          message,
          extension,
          extensionMessage
        )
        .catch((err) => {
          var message = "操作失败";
          if (err.response && err.response.data) {
            message = err.response.data.Message;
          }
          this.$toast(message);
          return;
        });
      if (res && res.status == 200) {
        this.$toast("操作成功");
        if (submitType == 1) {
          this.formReturn();
        } else if (submitType == 0) {
          this.getPst();
        }
      } else {
        this.$toast("操作失败");
      }
    },
    uploadchange() {
      this.getPst();
    },
    formReturn() {
      this.$router.back();
    },
    print() {
      let pstId = this.data.pst.id;
      this.$router.push({ name: "ReportPrint", params: { id: pstId } });
    },
    browser() {
      window.open(this.data.pst.pstUrl, "_blank");
    },
    tabclick(tab) {
      this.tabIndex = tab.index;
      if (this.tabIndex > 0) {
        this.data.currNode = this.data.nodes[this.tabIndex - 1];
      } else {
        this.data.currNode = "";
      }
    },
    radioChange(val) {
      if (this.data.form.extension > 0) {
        this.data.form.lsextension = this.data.form.extension;
      }
      if (val < 4) {
        if (this.data.form.isExtension == false) {
          this.data.form.extension = 0;
        }
      } else if (val == 4) {
        this.data.form.extension = -1;
      } else if (val == 5) {
        this.data.form.extension = this.data.form.lsextension;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 40px;
}

//工具栏样式
.cust_seach {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: 100%;
  padding: auto 5px;

  .btnLeft {
    flex: 1;
    margin: 0;

    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }

  .btnTitle {
    flex: 2;
    margin: 0;

    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }

  .btnStatus {
    flex: 1;
    margin: 0;

    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }

  .el-button-group>.el-button:first-child:last-child {
    border-radius: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}

.el-select {
  float: left;
}

.cust_pagin {
  display: flex;
  position: sticky;
  bottom: 0;
  z-index: 999;
}

/deep/.el-breadcrumb__separator {
  color: rgb(87, 86, 86);
}

/deep/.el-textarea.is-disabled .el-textarea__inner {
  background-color: #fefefe;
  border-color: #e4e7ed;
  color: #031944;
  cursor: auto;
}

/deep/.el-input.is-disabled .el-input__inner {
  background-color: #fefefe;
  border-color: #e4e7ed;
  color: #031944;
  cursor: auto;
}
</style>